import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
var CompanyService = /** @class */ (function () {
    function CompanyService(http, auth) {
        this.http = http;
        this.auth = auth;
        this.URL = environment.baseServerURL + "/administration/company";
        this.userRole = this.auth.user.role;
    }
    CompanyService.prototype.buildURL = function (subPath) {
        return this.URL + "/" + subPath;
    };
    CompanyService.prototype.getCompanyList = function () {
        if (this.userRole && this.userRole.name === 'superadmin') {
            return this.http.get(this.buildURL(''), {
                withCredentials: true
            }).pipe(map(function (result) {
                return result;
            }), catchError(function (err, caught) {
                console.error(err);
                return new Observable(function (observer) {
                    observer.next([]);
                    observer.complete();
                });
            }));
        }
        else {
            return new Observable(function (observer) {
                observer.next([]);
                observer.complete();
            });
        }
    };
    CompanyService.prototype.getCompany = function (id) {
        return this.http.get(this.buildURL(id), {
            withCredentials: true
        });
    };
    CompanyService.prototype.createCompany = function (company) {
        return this.http.post(this.buildURL(''), company, {
            withCredentials: true
        });
    };
    CompanyService.prototype.updateCompany = function (company) {
        return this.http.put(this.buildURL(company.id), company, {
            withCredentials: true
        });
    };
    CompanyService.prototype.deleteCompany = function (id) {
        return this.http.delete(this.buildURL(id), {
            withCredentials: true
        });
    };
    CompanyService.prototype.setupCompany = function (data) {
        var uploadData = new FormData();
        uploadData.append('file', data.xlsFile);
        uploadData.append('data', JSON.stringify(data));
        return this.http.post(this.buildURL(this.auth.user.company + "/setup"), uploadData, {
            withCredentials: true
        });
    };
    CompanyService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CompanyService_Factory() { return new CompanyService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: CompanyService, providedIn: "root" });
    return CompanyService;
}());
export { CompanyService };
